// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-fwwgl-ztwh-index-main_right_content-2Q7Lb","table":"components-fwwgl-ztwh-index-table-1-hwr"};


//////////////////
// WEBPACK FOOTER
// ./components/fwwgl/ztwh/index.css
// module id = 2290
// module chunks = 0